<template lang="html">
  <div class="" :style="stylechat" v-model="ListchatMenu">
    <v-row justify="center" align="center">
      <v-overlay
        :value="overlay"
        :z-index="zIndex"
        @click="closeDialog"
      >
        <div class="layout-menu">
          <v-col cols="12" align="center" @click="routePage('/creategroup')">
            <v-icon color="primary" class="pr-4">mdi-account-multiple-plus</v-icon>
            <span class="span-color">{{$t('AnswerQuestion.createGroup')}}</span>
          </v-col>
          <v-divider class="divider-color"></v-divider>
          <v-col cols="12" align="center" @click="routePage('/addfriend')">
            <v-icon color="primary" class="pr-4">mdi-account-plus</v-icon>
            <span class="span-color">{{$t('AnswerQuestion.addFriend')}}</span>
          </v-col>
        </div>
        <div class="layout-menu-close">
          <v-col cols="12" align="center" @click="closeDialog">
            <span class="span-color-close">{{$t('AnswerQuestion.cancel')}}</span>
          </v-col>
        </div>
      </v-overlay>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    ListchatMenu: Boolean
  },
  data () {
    return {
      overlay: false,
      zIndex: 1,
      stylechat: {
        "--ListchatMenu-HeaderColor": "white",
        "--ListchatMenu-TabBackground": "white",
        "--ListchatMenu-Icon": "gray",
        "--ListchatMenu-IconActive": "#2662ae",
        "--ListchatMenu-Background": "white",
        "--ListchatMenu-FontSize": "18px",
        "--ListchatMenu-FontColor": "black",
        "--ListchatMenu-FontSize-Status": "16px",
        "--ListchatMenu-FontColor-Status": "grey",
        "--ListchatMenu-Background-Input": "#E2E1E3",
        "--ListchatMenu-Color-Button": "#EFF2FE",
        "--ListchatMenu-FontColor-Button": "#2662ae",
        "--ListchatMenu-FontColor-Cancel-Button": "#cb1002",
        "--ListchatMenu-Color-Divider": "#eaeaea"
      },
    }
  },
  watch: {
    ListchatMenu () {
      // console.log(this.ListchatMenu)
      if (this.ListchatMenu) {
        this.overlay = true
      } else {
        this.overlay = false
      }
    }
  },
  methods: {
    closeDialog () {
      this.overlay = false
      this.$emit('closeListMenu', false)
    },
    routePage (path) {
      this.closeDialog()
      this.$router.push(path)
    }
  }
}
</script>

<style lang="css" scoped>
.divider-color {
  border-color: var(--ListchatMenu-Color-Divider) !important;
}
.span-color {
  color: var(--ListchatMenu-FontColor-Button) !important;
  font-size: var(--ListchatMenu-FontSize) !important;
  font-weight: 500;
}
.span-color-close {
  color: var(--ListchatMenu-FontColor-Cancel-Button) !important;
  font-size: var(--ListchatMenu-FontSize) !important;
  font-weight: 550;
}
>>>.v-overlay__content {
  align-items: center;
  justify-content: center;
  display: flex;
}
.layout-menu {
  height: auto;
  background-color: var(--ListchatMenu-Background) !important;
  width: 95% !important;
  border-radius: 15px;
  position: fixed;
  bottom: 70px;
  margin-left: 20px;
  margin-right: 20px;
  padding: 10px;
  /* display: flex;
  justify-content: center; */
}
.layout-menu-close {
  /* height: 45px; */
  background-color: var(--ListchatMenu-Background) !important;
  width: 95% !important;
  border-radius: 15px;
  position: fixed;
  bottom: 10px;
  margin-left: 20px;
  margin-right: 20px;
  /* padding: 10px; */
  /* display: flex;
  justify-content: center; */

}
</style>
